
const QUARTERS = {
  "01": "Jan-Mar",
  "02": "Jan-Mar",
  "03": "Jan-Mar",
  "04": "Apr-Jun",
  "05": "Apr-Jun",
  "06": "Apr-Jun",
  "07": "Jul-Sep",
  "08": "Jul-Sep",
  "09": "Jul-Sep",
  "10": "Oct-Dec",
  "11": "Oct-Dec",
  "12": "Oct-Dec",
}

const HALFYEARS = {
  "01": "Jan-Jun",
  "02": "Jan-Jun",
  "03": "Jan-Jun",
  "04": "Jan-Jun",
  "05": "Jan-Jun",
  "06": "Jan-Jun",
  "07": "Jul-Dec",
  "08": "Jul-Dec",
  "09": "Jul-Dec",
  "10": "Jul-Dec",
  "11": "Jul-Dec",
  "12": "Jul-Dec",
}




export function calcBiWeeklyData(firstDataArr, lastDataArr, uniqueSalesArr) {
    let newFirstData = [], newLastData = [], newUniqueSales = []
    let newFirstDataArr = [], newLastDataArr = [], newSalesDataArr = []

    let count = 0
    for (let i = firstDataArr.length - 1; i >= 0; i -= 2) {

        // Combine every two weeks together, starting from first week
        if (firstDataArr[i - 1] !== 0 && firstDataArr[i - 1] !== undefined) {
            newFirstData[count] = firstDataArr[i].concat(firstDataArr[i - 1])
            newLastData[count] = lastDataArr[i].concat(lastDataArr[i - 1])
            newUniqueSales[count] = uniqueSalesArr[i].concat(uniqueSalesArr[i - 1])
        } else {
            // For last data point when there is no i - 1
            newFirstData[count] = firstDataArr[i]
            newLastData[count] = lastDataArr[i]
            newUniqueSales[count] = uniqueSalesArr[i]
        }

        // Hash to check for duplicates and combine unique sales no
        let dataHash = []
        let salesHash = []
        for (let k = 0; k < newFirstData[count].length; k++) {
            // Key for identifying duplicates
            let key = `${newFirstData[count][k]} ${newLastData[count][k]}`
            const posOfRow = dataHash.findIndex(entry => entry[0] === key)

            if (posOfRow >= 0) {
                // Update count value in original data from duplicate
                salesHash[posOfRow] += newUniqueSales[count][k]
            } else {
                // Add data to arrays if not a duplicate
                dataHash.push([key, newFirstData[count][k], newLastData[count][k]])
                salesHash.push(newUniqueSales[count][k])
            }
        }
        // Turn new duplicate three hash arrays into arrays
        newFirstDataArr[count] = []
        newLastDataArr[count] = []
        newSalesDataArr[count] = []
        for (let j = 0; j < dataHash.length; j++) {
            newFirstDataArr[count][j] = dataHash[j][1]
            newLastDataArr[count][j] = dataHash[j][2]
            newSalesDataArr[count][j] = salesHash[j]
        }

        count++
    }

    return {
        firstSources: newFirstDataArr.reverse(),
        lastSources: newLastDataArr.reverse(),
        uniqueSales: newSalesDataArr.reverse()
    }
}








export function calcMonthlyData(firstDataArr, lastDataArr, uniqueSalesArr, weekList) {
    let newFirstData = [], newLastData = [], newSalesData = []
    let newFirst = [], newLast = [], newSales = []
    let weekDict = []

    let count = 0
    for (let i = 0; i < weekList.length; i++) {

        // Key for identifying week duplicates in same month
        let key = `${weekList[i].substring(0, 7)}`
        const findDup = weekDict.findIndex(entry => entry === key)

        if (findDup >= 0) {
            // Concat week's array to monthly array when in same month
            newFirstData[findDup] = newFirstData[findDup].concat(firstDataArr[i])
            newLastData[findDup] = newLastData[findDup].concat(lastDataArr[i])
            newSalesData[findDup] = newSalesData[findDup].concat(uniqueSalesArr[i])
        }
        else {
            // Initialize new monthly data with first week data
            weekDict.push(key)
            newFirstData.push(firstDataArr[i])
            newLastData.push(lastDataArr[i])
            newSalesData.push(uniqueSalesArr[i])
            count++
        }
    }


    for (let i = 0; i < count; i++) {
        // Hash to check for duplicates and combine unique sales no
        let dataHash = []
        let salesHash = []

        for (let k = 0; k < newFirstData[i].length; k++) {
            // Key for identifying duplicates
            let key = `${newFirstData[i][k]} ${newLastData[i][k]}`
            const posOfRow = dataHash.findIndex(entry => entry[0] === key)

            if (posOfRow >= 0) {
                // Update count value in original data from duplicate
                salesHash[posOfRow] += newSalesData[i][k]
            } else {
                // Add data to arrays if not a duplicate
                dataHash.push([key, newFirstData[i][k], newLastData[i][k]])
                salesHash.push(newSalesData[i][k])
            }
        }
        // Turn new duplicate free hash arrays into arrays
        newFirst[i] = []
        newLast[i] = []
        newSales[i] = []
        for (let j = 0; j < dataHash.length; j++) {
            newFirst[i][j] = dataHash[j][1]
            newLast[i][j] = dataHash[j][2]
            newSales[i][j] = salesHash[j]
        }
    }

    return {
        firstSources: newFirst,
        lastSources: newLast,
        uniqueSales: newSales
    }
}








export function calcQuarterlyData(firstDataArr, lastDataArr, uniqueSalesArr, weekList) {
    let newFirstData = [], newLastData = [], newSalesData = []
    let newFirst = [], newLast = [], newSales = []
    let weekDict = []

    let count = 0
    for (let i = 0; i < weekList.length; i++) {

        // Key for identifying week duplicates in same month
        let key = `${QUARTERS[`${weekList[i].substring(5, 7)}`]} ${weekList[i].substring(0, 5)}`
        const findDup = weekDict.findIndex(entry => entry === key)

        if (findDup >= 0) {
            // Concat week's array to monthly array when in same month
            newFirstData[findDup] = newFirstData[findDup].concat(firstDataArr[i])
            newLastData[findDup] = newLastData[findDup].concat(lastDataArr[i])
            newSalesData[findDup] = newSalesData[findDup].concat(uniqueSalesArr[i])
        }
        else {
            // Initialize new monthly data with first week data
            weekDict.push(key)
            newFirstData.push(firstDataArr[i])
            newLastData.push(lastDataArr[i])
            newSalesData.push(uniqueSalesArr[i])
            count++
        }
    }


    for (let i = 0; i < count; i++) {
        // Hash to check for duplicates and combine unique sales no
        let dataHash = []
        let salesHash = []

        for (let k = 0; k < newFirstData[i].length; k++) {
            // Key for identifying duplicates
            let key = `${newFirstData[i][k]} ${newLastData[i][k]}`
            const posOfRow = dataHash.findIndex(entry => entry[0] === key)

            if (posOfRow >= 0) {
                // Update count value in original data from duplicate
                salesHash[posOfRow] += newSalesData[i][k]
            } else {
                // Add data to arrays if not a duplicate
                dataHash.push([key, newFirstData[i][k], newLastData[i][k]])
                salesHash.push(newSalesData[i][k])
            }
        }
        // Turn new duplicate free hash arrays into arrays
        newFirst[i] = []
        newLast[i] = []
        newSales[i] = []
        for (let j = 0; j < dataHash.length; j++) {
            newFirst[i][j] = dataHash[j][1]
            newLast[i][j] = dataHash[j][2]
            newSales[i][j] = salesHash[j]
        }
    }

    return {
        firstSources: newFirst,
        lastSources: newLast,
        uniqueSales: newSales
    }
}





export function calcHalfYearlyData(firstDataArr, lastDataArr, uniqueSalesArr, weekList) {
    let newFirstData = [], newLastData = [], newSalesData = []
    let newFirst = [], newLast = [], newSales = []
    let weekDict = []

    let count = 0
    for (let i = 0; i < weekList.length; i++) {

        // Key for identifying week duplicates in same month
        let key = `${HALFYEARS[`${weekList[i].substring(5, 7)}`]} ${weekList[i].substring(0, 5)}`
        const findDup = weekDict.findIndex(entry => entry === key)

        if (findDup >= 0) {
            // Concat week's array to monthly array when in same month
            newFirstData[findDup] = newFirstData[findDup].concat(firstDataArr[i])
            newLastData[findDup] = newLastData[findDup].concat(lastDataArr[i])
            newSalesData[findDup] = newSalesData[findDup].concat(uniqueSalesArr[i])
        }
        else {
            // Initialize new monthly data with first week data
            weekDict.push(key)
            newFirstData.push(firstDataArr[i])
            newLastData.push(lastDataArr[i])
            newSalesData.push(uniqueSalesArr[i])
            count++
        }
    }


    for (let i = 0; i < count; i++) {
        // Hash to check for duplicates and combine unique sales no
        let dataHash = []
        let salesHash = []

        for (let k = 0; k < newFirstData[i].length; k++) {
            // Key for identifying duplicates
            let key = `${newFirstData[i][k]} ${newLastData[i][k]}`
            const posOfRow = dataHash.findIndex(entry => entry[0] === key)

            if (posOfRow >= 0) {
                // Update count value in original data from duplicate
                salesHash[posOfRow] += newSalesData[i][k]
            } else {
                // Add data to arrays if not a duplicate
                dataHash.push([key, newFirstData[i][k], newLastData[i][k]])
                salesHash.push(newSalesData[i][k])
            }
        }
        // Turn new duplicate free hash arrays into arrays
        newFirst[i] = []
        newLast[i] = []
        newSales[i] = []
        for (let j = 0; j < dataHash.length; j++) {
            newFirst[i][j] = dataHash[j][1]
            newLast[i][j] = dataHash[j][2]
            newSales[i][j] = salesHash[j]
        }
    }

    return {
        firstSources: newFirst,
        lastSources: newLast,
        uniqueSales: newSales
    }
}



